import { render, staticRenderFns } from "./WorkFlowCategoryCreate.vue?vue&type=template&id=dcbbbb22&"
import script from "./WorkFlowCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./WorkFlowCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports